import * as React from 'react';
import * as Sebrae from '@sebrae/react-core';
import { AppContext } from '../../components/shared/context';
import { v2, version } from '../../constants/endpoints';

export const useLancamento = () => {
  const { empresa } = React.useContext(AppContext);
  const { backendGet, backendPost, backendPut, backendDelete, backendGetBlob } =
    Sebrae.useBackend();

  const pathLancamento = React.useMemo(() => {
    const endpointVersion = empresa?.isConvidado ? version : v2;
    return `${endpointVersion}/lancamento${
      empresa?.isConvidado ? '/convidado' : ''
    }?origem=FLUXO`;
  }, [empresa]);

  const salvarLancamento = React.useCallback(
    (data) => backendPost(pathLancamento, data),
    [backendPost, pathLancamento],
  );

  const atualizarLancamento = React.useCallback(
    (data) => backendPut(pathLancamento, data),
    [backendPut, pathLancamento],
  );

  const excluirLancamento = React.useCallback(
    (cnpj, id, opcaoAlteracao) => {
      const endpoint = opcaoAlteracao
        ? `${version}/lancamento/${id}/empresa/${empresa?.id}/${opcaoAlteracao}`
        : `${version}/lancamento/${id}/empresa/${empresa?.id}`;
      return backendDelete(endpoint);
    },
    [backendDelete, empresa],
  );

  const downloadXLS = React.useCallback(
    (cnpj) =>
      backendGetBlob(`${v2}/lancamento/export/xls/${empresa?.id}`, {
        responseType: 'arraybuffer',
      }),
    [backendGetBlob, empresa],
  );

  const downloadCSV = React.useCallback(
    (cnpj) =>
      backendGetBlob(`${v2}/lancamento/export/csv/${empresa?.id}`, {
        responseType: 'arraybuffer',
      }),
    [backendGetBlob, empresa],
  );

  const excluirTodosLancamentos = React.useCallback(
    (cnpj) => backendDelete(`${v2}/lancamento/todos/${empresa?.id}`),
    [backendDelete, empresa],
  );

  const buscarLancamentoMesAtual = React.useCallback(
    (cnpj) => backendGet(`${v2}/lancamento/empresa/${empresa?.id}`),
    [backendGet, empresa],
  );

  const buscarLancamentoPorFiltro = React.useCallback(
    (start, end) =>
      backendGet(
        `${v2}/lancamento/empresa/${empresa?.id}/periodo?dataInicio=${start}&dataFim=${end}`,
      ),
    [backendGet, empresa],
  );

  const buscaLancamentoPorId = React.useCallback(
    (idLancamento) => backendGet(`${version}/lancamento/${idLancamento}`),
    [backendGet],
  );

  const buscarInvestimentos = React.useCallback(
    () => backendGet(`${v2}/lancamento/${empresa?.id}/investimentos`),
    [backendGet, empresa],
  );

  const importLancamentoFile = React.useCallback(
    (formData, onUpload) =>
      backendPost(`${version}/lancamento/import/planilha`, formData, {
        onUploadProgress: onUpload,
      }),
    [backendPost],
  );

  const importLancamentoArray = React.useCallback(
    (array) =>
      backendPost(`${version}/lancamento/planilha?origem=FLUXO`, array),
    [backendPost],
  );

  const lancamentoAutomaticoMei = React.useCallback(
    (cnpj, ano) =>
      backendPost(
        `${version}/lancamento/automatico-mei/empresa/${empresa?.id}/ano/${ano}?origem=FLUXO`,
      ),
    [backendPost, empresa],
  );

  return {
    salvarLancamento,
    atualizarLancamento,
    excluirLancamento,
    downloadXLS,
    downloadCSV,
    excluirTodosLancamentos,
    buscarLancamentoMesAtual,
    buscarLancamentoPorFiltro,
    buscaLancamentoPorId,
    buscarInvestimentos,
    importLancamentoFile,
    importLancamentoArray,
    lancamentoAutomaticoMei,
  };
};
